const UNAUTHORIZED = 'E_UNAUTHORIZED';
const NOT_FOUND = 'E_NOT_FOUND';
const CONFLICT = 'E_CONFLICT';

export default {
  UNAUTHORIZED,
  NOT_FOUND,
  CONFLICT,
};
